import React from 'react';
import Layout from '../../components/Layout';
export { default as DailyTripReportPage } from './DailyTripReportPage';
export { default as PSACCBillingReportPage } from './PSACCBillingReportPage';
export { default as PSACCBillingStripReportPage } from './PSACCBillingStripReportPage';

export function WaybillReportPage() {
  return <Layout pageTitle="Waybill Report"><div className="text-gray-400 p-8">Waybill report — coming soon.</div></Layout>;
}
export function FFBillingReportPage() {
  return <Layout pageTitle="FF Billing Statement"><div className="text-gray-400 p-8">FF Billing Statement — coming soon.</div></Layout>;
}
export function TruckingBillingReportPage() {
  return <Layout pageTitle="Trucking Billing Statement"><div className="text-gray-400 p-8">Trucking Billing Statement — coming soon.</div></Layout>;
}
// DailyTripReportPage, PSACCBillingReportPage, PSACCBillingStripReportPage are re-exported above from their own files.
export function BillingPettyCashReportPage() {
  return <Layout pageTitle="Petty Cash Report"><div className="text-gray-400 p-8">Petty Cash Report — coming soon.</div></Layout>;
}
